module.exports = __webpack_public_path__ + "static/img/movie.65f4ff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/movie.jpg
// module id = nnMy
// module chunks = 1